import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';

@Exclude()
export class StaticPageApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public slug: string;
  @Expose() public publicSlug: string;
  @Expose() public status: string;
  @Expose() public documentType: string;
  @Expose() public title: string;
  @Expose() public excerpt: string | null;
  @Expose() public content: string;
  @Expose() public metaTitle: string | null;
  @Expose() public metaDescription: string | null;
  @Expose() public showInLandingFooter = false;
  @Expose() public showInAppMenu = false;
  @Type(() => Date)
  @Expose() public createdAt: Date;
  @Type(() => Date)
  @Expose() public updatedAt: Date;
}
